import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LanguageChangeService } from './language-change.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private apiUrl = environment.apiUrl + '/events';

  constructor(
    private http: HttpClient,
    private languageChangeService: LanguageChangeService,
    private TranslationService: TranslationService
  ) { }

  getEvents(): Observable<any[]> {
    const lang = this.TranslationService.getCurrentLanguage();
    return this.http.get<any[]>(`${this.apiUrl}?lang=${lang}`);
  }

  getEvent(id: any): Observable<any> {
    const lang = this.TranslationService.getCurrentLanguage();
    return this.http.get<any>(`${this.apiUrl}/${id}?lang=${lang}`);
  }

  createOrUpdate(formData: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/createOrUpdate', formData);
  }


  deleteEvent(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/delete/${id}`);
  }

  generateWithIa(formData: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/generateia', formData);
  }
}
